import type { CSSProperties, ReactNode } from 'react';
import { styleVars } from '../lib/style.ts';

export type CardVariant = 'light' | 'panel' | 'dark';

export interface CardProps {
  children: ReactNode;
  /** `light` is the default page card; `panel` is for inline forms; `dark` promotes key content. */
  variant?: CardVariant;
  /** Inner padding. Pass '0' for a card whose child is a full-bleed table. */
  pad?: string;
  gap?: string;
  className?: string;
  style?: CSSProperties;
}

export function Card({ children, variant = 'light', pad, gap, className, style }: CardProps) {
  const classes = ['card', `card${variant.charAt(0).toUpperCase()}${variant.slice(1)}`, className]
    .filter(Boolean)
    .join(' ');
  return (
    <section className={classes} style={{ ...styleVars({ '--pad': pad, '--gap': gap }), ...style }}>
      {children}
    </section>
  );
}

export interface CardHeaderProps {
  title: ReactNode;
  meta?: ReactNode;
  action?: ReactNode;
  onDark?: boolean;
}

export function CardHeader({ title, meta, action, onDark = false }: CardHeaderProps) {
  return (
    <header className={onDark ? 'cardHeader cardHeaderOnDark' : 'cardHeader'}>
      <h2 className="typeCardTitle">{title}</h2>
      {meta ? <span className="cardHeaderMeta">{meta}</span> : null}
      {action}
    </header>
  );
}
